import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import swal from "sweetalert";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MUIDataTable from "mui-datatables";
import { API_URL } from "../../config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";

import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { pathSpliter, checkAuthBranchWare, sortRecordsNewestFirst } from "../../lib/functions";
import {
  currentRouteSet,
  createdReceiverSet,
  updatedReceiverSet,
  disableRestoreReceiverSet,
} from "../../actions/actions";

const OrderInfo = ({
  location,
  currentRouteSet,
  authInfo,
  receiverCodeAction,
  createdReceiver,
  updatedReceiver,
  receiverDisableRestore,
  createdReceiverSet,
  updatedReceiverSet,
  disableRestoreReceiverSet,
}) => {
  const classes = useStyles();
  let [formValues, formSetValues] = useState({
    action: "create",
    order_id: 0,
    receiver_id: 0,
    order_code: "",
    order_name: "",
    order_mobile_no: "",
    receiver_name: "",
    receiver_mobile_no: "",

  });
  let [loadingSave, loadingSaveSet] = useState(false);
  let [loadingList, loadingListSet] = useState(false);
  let [receiverUpdateIndex, receiverUpdateIndexSet] = useState("0");

  let [receivers, receiversSet] = useState([]);
  let [receiverCode, receiverCodeSet] = useState("");

  let orderCodeRef = React.useRef(null);
  let orderNameRef = React.useRef(null);
  let orderMobileRef = React.useRef(null);
  let receiverNameRef = React.useRef(null);
  let receiverMobileRef = React.useRef(null);
  let receiverActionRef = React.useRef(null);

  const [successMsg, setSuccessMsg] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    msg: "",
  });

  const { vertical, horizontal, open, msg } = successMsg;
  const handleClose = () => {
    setSuccessMsg({ ...successMsg, open: false });
  };

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getOrders();
    // getReceiverCode();
  }, []);

  const getReceiverCode = async () => {
    await axios
      .get(`${API_URL}/api/get-order-code`, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        receiverCodeSet(res.data.message);
      });
  };


  const getOrders = async () => {
    loadingListSet(true);
    await axios
      .post(`${API_URL}/api/get-orders`, null, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        loadingListSet(false);
        receiversSet(sortRecordsNewestFirst(res.data.message || []));
      });
  };

  //  const getOrders = async () => {
  //   loadingListSet(true);
  //   try {
  //     const res = await axios.post(`${API_URL}/api/get-orders`, null, {
  //       headers: { "auth-token": authInfo.token },
  //     });

  //     const orders = res.data.message; // this should be an array of objects
  //     if (!Array.isArray(orders)) {
  //       throw new Error("Expected 'message' to be an array of orders");
  //     }

  //     // Transform into array of arrays (rows) for mui-datatables
  //     const transformed = orders.map((order) => ([
  //       order.order_code,
  //       order.order_date,
  //       order.customer_name,
  //       order.status,
  //       order.receiver_name,
  //       order.receiver_phone,
  //       order.receiver_address,
  //       order.invoice_no,
  //       order.invoice_date,
  //       order.grand_total,
  //       order.action, // or define it inside render()
  //     ]));

  //     receiversSet(transformed);
  //   } catch (error) {
  //     console.error("Failed to fetch orders:", error);
  //   } finally {
  //     loadingListSet(false);
  //   }
  // };


  useEffect(() => {
    if (receiverCodeAction) {
      if (formValues.action == "create") {
        receiverCodeSet(receiverCodeAction.createdRow);
      }
    }
  }, [receiverCodeAction]);

  // supplier  Real time start
  useEffect(() => {
    if (createdReceiver) {
      if (checkAuthBranchWare(createdReceiver.user_branch_id)) {
        receiversSet(sortRecordsNewestFirst(createdReceiver.createdRow.concat(receivers)));
        setSuccessMsg({
          ...successMsg,
          msg: `${createdReceiver.msg}`,
          open: true,
        });
      }
    }
  }, [createdReceiver]);

  useEffect(() => {
    if (updatedReceiver) {
      if (checkAuthBranchWare(updatedReceiver.user_branch_id)) {
        receivers[updatedReceiver.index] = updatedReceiver.updatedRow[0];
        setSuccessMsg({
          ...successMsg,
          msg: `${updatedReceiver.msg}`,
          open: true,
        });
      }
    }
  }, [updatedReceiver]);

  useEffect(() => {
    if (receiverDisableRestore) {
      if (checkAuthBranchWare(receiverDisableRestore.user_branch_id)) {
        receivers[receiverDisableRestore.index] =
          receiverDisableRestore.disableRestoreRow[0];
        setSuccessMsg({
          ...successMsg,
          msg: `${receiverDisableRestore.msg}`,
          open: true,
        });
      }
    }
  }, [receiverDisableRestore]);

  useEffect(() => {
    createdReceiverSet(null);
    updatedReceiverSet(null);
    disableRestoreReceiverSet(null);
  }, []);


  const handleFromInput = (e) => {
    const { name, value } = e.target;
    formSetValues({ ...formValues, [name]: value });
  };
  const saveFormAction = async () => {
    const orderCode = String(formValues.order_code ?? "").trim();
    const orderName = String(formValues.order_name ?? "").trim();
    const orderMobileNo = String(formValues.order_mobile_no ?? "").trim();
    const receiverName = String(formValues.receiver_name ?? "").trim();
    const receiverMobileNo = String(formValues.receiver_mobile_no ?? "").trim();

    if (orderCode == "") {
      swal({
        title: "Order Code is required.",
        icon: "warning",
      });
    } else if (orderName == "") {
      swal({
        title: "Buyer name is required.",
        icon: "warning",
      });
    }
    else if (orderMobileNo == "") {
      swal({
        title: "Buyer mobile no is required.",
        icon: "warning",
      });
    } else if (receiverName == "") {
      swal({
        title: "Receiver name is required.",
        icon: "warning",
      });
    } else if (receiverMobileNo == "") {
      swal({
        title: "Receiver mobile no is required.",
        icon: "warning",
      });
    }
    else {
      loadingSaveSet(true);
      try {
        const res = await axios.post(
          `${API_URL}/api/order-info`,
          {
            ...formValues,
            order_id: formValues.order_id || 0,
            orderId: formValues.order_id || 0,
            receiver_id: formValues.receiver_id || 0,
            receiverId: formValues.receiver_id || 0,
            order_code: orderCode,
            order_name: orderName,
            order_mobile_no: orderMobileNo,
            receiver_name: receiverName,
            receiver_mobile_no: receiverMobileNo,
          },
          {
            headers: { "auth-token": authInfo.token },
          }
        );
        loadingSaveSet(false);

        if (res.data.error) {
          swal({
            title: `${res.data.message}`,
            icon: "warning",
          });
          return false;
        }

        formSetValues({
          ...formValues,
          order_id: 0,
          receiver_id: 0,
          order_code: "",
          order_name: "",
          order_mobile_no: "",
          receiver_name: "",
          receiver_mobile_no: "",
          action: "create",
        });
        getReceiverCode();
        await getOrders();
      } catch (error) {
        loadingSaveSet(false);
        swal({
          title: error?.response?.data?.message || "Failed to save order info",
          icon: "error",
        });
      }
    }
  };

  const receiverEdit = (row, index) => {
    const selectedRow = receivers[index] || {};
    receiverCodeSet(selectedRow.receiver_code);
    formSetValues({
      ...formValues,
      order_id: selectedRow.order_id || selectedRow.orderId || selectedRow.id || row?.[0] || 0,
      receiver_id: selectedRow.receiver_id || selectedRow.receiverId || 0,
      order_code: selectedRow.order_code || "",
      order_name: selectedRow.order_name || selectedRow.order_by_name || "",
      order_mobile_no: selectedRow.order_mobile_no || selectedRow.order_by_mobile || "",
      receiver_name: selectedRow.receiver_name || "",
      receiver_mobile_no: selectedRow.receiver_mobile_no || selectedRow.receiver_mobile || "",
      action: "update",
    });

    receiverUpdateIndexSet(index);
  };
  const cusomerDisableRestore = async (receiverId, actionCond, index, rowData = []) => {
    if (actionCond === "disable") {
      const willContinue = await swal({
        title: "Are you sure?",
        text: "Do you want to delete this receiver?",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      });
      if (!willContinue) return;
    }

    const selectedRow = receivers[index] || {};
    const orderId =
      selectedRow.order_id ||
      selectedRow.orderId ||
      selectedRow.id ||
      rowData?.[0] ||
      selectedRow.receiver_id ||
      selectedRow.receiverId ||
      receiverId ||
      0;
    const receiverRowId = selectedRow.receiver_id || selectedRow.receiverId || receiverId || 0;
    const actionAlias = actionCond === "disable" ? "d" : actionCond === "restore" ? "a" : actionCond;

    try {
      const res = await axios.post(
        `${API_URL}/api/order-disable-restore`,
        {
          action: actionAlias,
          index,
          order_id: orderId,
          orderId,
          receiver_id: receiverRowId,
          receiverId: receiverRowId,
        },
        { headers: { "auth-token": authInfo.token } }
      );

      if (res?.data?.error) {
        swal({
          title: res.data.message || "Failed to update order info",
          icon: "error",
        });
        return;
      }

      if (actionCond === "disable") {
        receiversSet((prev) => prev.filter((_, idx) => idx !== index));
      }
      await getOrders();
    } catch (error) {
      swal({
        title: error?.response?.data?.message || "Failed to update order info",
        icon: "error",
      });
    }
  };
  console.log("Prohlad Orders:", receivers)
  const ActionOptions = (props) => {
    return (
      <div style={{ textAlign: "right" }}>
        {authInfo.role != "user" ? (
          <>
            <EditIcon
              style={{
                cursor: "pointer",
                fontSize: "28px",
                color: "rgb(15, 126, 119)",
              }}
              onClick={() => receiverEdit(props.rowData, props.rowIndex)}
            />
            {props.rowData[1] == "active" ? (
              <DeleteIcon
                style={{
                  cursor: "pointer",
                  color: "#ff0202",
                  fontSize: "28px",
                }}
                onClick={() =>
                  cusomerDisableRestore(
                    props.rowData[0],
                    "disable",
                    props.rowIndex,
                    props.rowData
                  )
                }
              />
            ) : (
              <SettingsBackupRestoreIcon
                style={{
                  cursor: "pointer",
                  color: "rgb(60, 178, 194)",
                  fontSize: "28px",
                }}
                onClick={() =>
                  cusomerDisableRestore(
                    props.rowData[0],
                    "restore",
                    props.rowIndex,
                    props.rowData
                  )
                }
              />
            )}
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const columns = [
    { name: "orderId", options: { display: "excluded" } },
    { name: "order_status", options: { display: "excluded" } },
    {
      name: "SL",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return <p>{parseFloat(tableMeta.rowIndex) + 1}</p>;
        },
      },
      headerStyle: {
        textAlign: "left",
      },
    },
    {
      name: "order_code",
      label: "Order Code",
      options: { filter: true, sort: true },
    },
    {
      name: "order_by_name",
      label: "Order By",
      options: { filter: true, sort: true },
    },
    {
      name: "order_by_mobile",
      label: "Order Mobile",
      options: { filter: true, sort: true },
    },
    {
      name: "receiver_name",
      label: "Receiver Name",
      options: { filter: true, sort: true },
    },
    {
      name: "receiver_mobile",
      label: "Mobile No",
      options: { filter: true, sort: true },
    },
    {
      name: "actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <ActionOptions
              value={value}
              rowIndex={tableMeta.rowIndex}
              rowData={tableMeta.rowData}
            />
          );
        },
      },
      headerStyle: {
        textAlign: "right",
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    display: "excluded",
  };

  return (
    <div className={classes.root}>
      {/* Success message */}
      <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {successMsg.msg}
        </Alert>
      </Snackbar>
      {/* End of message */}
      <Paper className={classes.paper} style={{ marginTop: "-15px" }}>
        <h2 className={classes.pageEntryLabel}>Order Info</h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={formValues.order_code}
              label="Order Code"
              name="order_code"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={handleFromInput}
              inputRef={orderCodeRef}

            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={formValues.order_name}
              label="Order By"
              name="order_name"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={handleFromInput}
              inputRef={orderNameRef}

            />
          </Grid>


          <Grid item xs={12} sm={3}>

            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={formValues.order_mobile_no}
              label="Order Mobile"
              name="order_mobile_no"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,11}$/.test(value)) {
                  // Allow only up to 11 digits
                  handleFromInput(e); // Update form values
                }
              }}
              inputRef={orderMobileRef}
              error={
                formValues.order_mobile_no?.length > 0 &&
                formValues.order_mobile_no.length !== 11
              }
              helperText={
                formValues.order_mobile_no?.length > 0 &&
                  formValues.order_mobile_no.length !== 11
                  ? "Mobile number must be exactly 11 digits"
                  : ""
              }

            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={formValues.receiver_name}
              label="Receiver Name"
              name="receiver_name"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={handleFromInput}
              inputRef={receiverNameRef}

            />
          </Grid>
          <Grid item xs={12} sm={3}>

            <TextField
              autoComplete="off"
              className={classes.fullWidth}
              value={formValues.receiver_mobile_no}
              label="Receiver Mobile"
              name="receiver_mobile_no"
              style={{ color: "#222" }}
              variant="outlined"
              size="small"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,11}$/.test(value)) {
                  // Allow only up to 11 digits
                  handleFromInput(e); // Update form values
                }
              }}
              inputRef={orderMobileRef}
              error={
                formValues.receiver_mobile_no?.length > 0 &&
                formValues.receiver_mobile_no.length !== 11
              }
              helperText={
                formValues.receiver_mobile_no?.length > 0 &&
                  formValues.receiver_mobile_no.length !== 11
                  ? "Mobile number must be exactly 11 digits"
                  : ""
              }

            />
          </Grid>

        </Grid>

        <Grid item xs={12}>
          <Button
            style={{ marginTop: "25px" }}
            variant="contained"
            color="primary"
            size="small"
            buttonRef={receiverActionRef}
            className={classes.button}
            startIcon={<SaveIcon />}
            disabled={loadingSave}
            onClick={saveFormAction}
          >
            Save
          </Button>
        </Grid>
      </Paper>
      {loadingList == true ? (
        <b>Loading...</b>
      ) : (
        <Paper className={classes.paper} style={{ marginTop: "20px" }}>
          <MUIDataTable
            title={"Receiver List"}
            data={receivers}
            columns={columns}
            options={options}
            adjustForCheckbox={false}
            displaySelectAll={false}
          />
        </Paper>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {},
  "& .MuiTextField-root": {
    margin: theme.spacing(1),
    width: "25ch",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  pageEntryLabel: {
    color: "#7754cc",
    margin: "0px",
    padding: "0px",
    marginTop: "-11px",
    textAlign: "left",
    marginLeft: "0px",
    marginBottom: "5px",
    textAlign: "left",
  },
  fullWidth: {
    width: "100%",
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
    receiverCodeAction: state.receiverCodeReducer,
    createdReceiver: state.createdreceiverReducer,
    updatedReceiver: state.updatedreceiverReducer,
    receiverDisableRestore: state.receiverDisableRestoreReducer,
  };
};

export default connect(mapStateToPops, {
  currentRouteSet,
  createdReceiverSet,
  updatedReceiverSet,
  disableRestoreReceiverSet,
})(OrderInfo);
